import { t } from "@/i18n-js/instance";
import { settingsNavPathV3 } from "@circle-react/helpers/urlHelpers";
import { NavGroup } from "../NavGroup";
import { SubNavLinkItem } from "./SubNavLinkItem";
import type { Link } from "./types";

export const PaywallsAffiliatesLinks = () => {
  const links: Link[] = [
    {
      label: t("settings_nav_v3.paywalls_affiliates.directory"),
      path: settingsNavPathV3.affiliates.directory,
      exact: true,
    },
    {
      label: t("settings_nav_v3.paywalls_affiliates.commissions"),
      path: settingsNavPathV3.affiliates.commissions,
      exact: true,
    },
    {
      label: t("settings_nav_v3.paywalls_affiliates.settings"),
      path: settingsNavPathV3.affiliates.settings,
      exact: true,
    },
  ];

  return (
    <NavGroup groupLinks={links}>
      <NavGroup.Content title={t("settings_nav_v3.paywalls_affiliates.label")}>
        {links.map(link => (
          <SubNavLinkItem key={link.path} label={link.label} path={link.path} />
        ))}
      </NavGroup.Content>
    </NavGroup>
  );
};
